import { useQuery, type UseQueryOptions } from "@tanstack/react-query";

import type { GetIndustryCategoryListResponseDto } from "../../dtos/get-industry-category-list-response-dto";
import { ProductQueryKeys } from "../../generators/product-query-keys";
import { ProductService } from "../../services/product-service";

type UseGetIndustryCategoryListQueryParams = {
  options?: UseQueryOptions<GetIndustryCategoryListResponseDto>;
};

export const useGetIndustryCategoryListQuery = ({
  options
}: UseGetIndustryCategoryListQueryParams = {}) => {
  return useQuery({
    queryKey: ProductQueryKeys.getIndustryCategoryList().queryKey,
    queryFn: async () => await ProductService.getIndustryCategoryList(),
    ...options
  });
};
